import axios from 'axios'
import Cookies from 'js-cookie'
import firebase from './../libs/firebase'
const firebaseTokenStart = '$mesh-fb:'
const readOnlyTokenStart = '$mesh-read-only:'
const buildToken = (tkType = undefined, token) => {
  if (tkType === 'fb' || tkType === undefined) {
    return firebaseTokenStart + Cookies.get('userToken')
  }
  if (tkType === 'readOnly') {
    return readOnlyTokenStart + token
  }
  if (tkType === 'cookieOnly') {
    return Cookies.get('userToken')
  }
  return ''
}
const getConfigWithBearer = (customToken = undefined, tkType = undefined) => {
  const userToken = buildToken(tkType, customToken)
  const config = {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${userToken}`
    },
    'Content-Type': 'application/json'
  }
  return userToken ? config : {}
}

export const tokenAxios = axios.create()
export const customAxios = axios.create()

customAxios.interceptors.response.use(
  function (response) {
    // If the request succeeds, we don't have to do anything and just return the response
    return response
  },
  function (error) {
    const errorResponse = error.response
    console.warn('interceptor: got an error...')
    const user = firebase.auth().currentUser
    console.log('interceptor: current user--->', user)

    if (errorResponse && isTokenExpiredError(errorResponse)) {
      const rq = resetTokenAndReattemptRequest(error)
      return rq
    }
    // If the error is due to other reasons, we just throw it back to axios
    return Promise.reject(error)
  }
)
function isTokenExpiredError(errorResponse) {
  // Your own logic to determine if the error is due to JWT token expired returns a boolean value
  if (errorResponse.status === 401) {
    const userTokenExpireTime = Cookies.get('userTokenExpiresAt')
      ? new Date(Cookies.get('userTokenExpiresAt'))
      : null
    if (
      errorResponse.data.refresh_id_token ||
      (userTokenExpireTime && userTokenExpireTime.getSeconds() - new Date().getSeconds() <= 0)
    ) {
      console.warn('Token expired at:', userTokenExpireTime.toLocaleTimeString())
      return true
    }
    // console.log('token expired?', userTokenExpire)
    return false
    // if (userTokenExpire === undefined){
    //     return true;
    // }
    // return false
  }
  return false
}
let isAlreadyFetchinguserToken = false

// This is the list of waiting requests that will retry after the JWT refresh complete
let subscribers = []

function resetTokenAndReattemptRequest(error) {
  try {
    const { response: errorResponse } = error
    // const resetToken = await TokenUtils.getResetToken();
    // Your own mechanism to get the refresh token to refresh the JWT token
    const resetToken = '' // Your own mechanism to get the refresh token to refresh the JWT token
    // if (!resetToken) {
    //     // We can't refresh, throw the error anyway
    //     return Promise.reject(error);
    // }
    /* Proceed to the token refresh procedure
    We create a new Promise that will retry the request,
    clone all the request configuration from the failed
    request in the error object. */
    const retryOriginalRequest = new Promise((resolve) => {
      /* We need to add the request retry to the queue
      since there another request that already attempt to
      refresh the token */
      addSubscriber((access_token) => {
        errorResponse.config.headers.Authorization = 'Bearer ' + firebaseTokenStart + access_token
        resolve(axios(errorResponse.config))
      })
    })
    if (!isAlreadyFetchinguserToken) {
      isAlreadyFetchinguserToken = true
      const user = firebase.auth().currentUser
      console.log('Getting new token.', user)

      if (user) {
        // User is signed in.
        user
          .getIdToken(true)
          .then((tkn) => {
            console.log('...forced a refresh of token')
            isAlreadyFetchinguserToken = false
            // listener in AppRoot will trigger further updates
            // but for now just pass the token to complete pending requests
            onUserTokenFetched(tkn)
          })
          .catch((e) => {
            console.warn('....Could not get a new token')
            console.error(e.message)
            return Promise.reject(e)
          })
      } else {
        // No user is signed in.
        console.warn('Not signed in')
        window.location = '/login'
        return Promise.reject()
      }
      // const response = post('/api/refresh', {})
      // response
      //   .then((response) => {
      //     const newToken = response.data.access_token
      //
      //     Cookies.set('userToken', response.data.access_token)
      //     Cookies.set('userTokenExpiresIn', response.data.expires_in)
      //     // TokenUtils.saveRefreshToken(newToken); // save the newly refreshed token for other requests to use
      //     isAlreadyFetchinguserToken = false
      //     onUserTokenFetched(newToken)
      //   })
      //   .catch((errors) => {
      //     if (errors.response.data && errors.response.data.must_login) {
      //       window.location = '/login'
      //     }
      //
      //     console.warn('....Could not get a new token')
      //     return Promise.reject(errors)
      //   })
      // // if (!response.data) {
      // //     console.warn("rejecting...")
      // //     return Promise.reject(error);
      // // }
    }
    return retryOriginalRequest
  } catch (err) {
    console.warn('All attempts to login failed')
    return Promise.reject(err)
  }
}

function onUserTokenFetched(userToken) {
  // When the refresh is successful, we start retrying the requests one by one and empty the queue
  subscribers.forEach((callback) => callback(userToken))
  subscribers = []
}

function addSubscriber(callback) {
  subscribers.push(callback)
}
// --------------------------------------------------------------------------------------------------------------------
export const post = async (url, data, options = {}) => {
  const { submittingState, useBearer = true, customToken, tkType } = options
  submittingState && submittingState(true)
  let config = useBearer ? getConfigWithBearer(customToken, tkType) : null
  return await customAxios.post(url, data, config && config)
}
export const patch = async (url, data, submittingState = null, useBearer = true) => {
  submittingState && submittingState(true)
  const config = useBearer ? getConfigWithBearer() : null
  data['_method'] = 'PATCH'
  return await customAxios.post(url, data, config && config)
}
export const get = async (url, options = {}) => {
  const { fetchingState, useBearer = true, customToken, tkType } = options
  fetchingState && fetchingState(true)
  const config = useBearer ? getConfigWithBearer(customToken, tkType) : null
  
  const axiosHandler = customToken ? tokenAxios : customAxios
  return axiosHandler.get(url, config && config)
}
export const destroy = async (url, submittingState = null, useBearer = true) => {
  submittingState && submittingState(true)
  const config = useBearer ? getConfigWithBearer() : null
  // config['_method'] = "DELETE"

  return await customAxios.delete(url, config && config)
}
